<template>
  <div id="wangeditor" class="wangeditor">
    <div ref="editorElem" style="text-align:left;background-color: #fff;"></div>
  </div>
</template>

<script>
import E from 'wangeditor'

export default {
  name: 'wangeditor',
  data () {
    return {
      url:'https://yzt-meeting.ysddong.com/yishantong-ui/fileUpload/list/batch',
      editorContent: '',
      editor: null,
    }
  },
  props:['catchData'],  //接收父组件的方法
  mounted() {


    this.editor = new E(this.$refs.editorElem)    //创建富文本实例
    this.editor.config.onchange = (html) => {
      this.editorContent = html;
      this.catchData(this.editorContent) //把这个html通过catchData的方法传入父组件
    };
    this.editor.config.uploadImgServer = this.url;
    this.editor.config.uploadFileName = 'files';
    this.editor.config.uploadImgHeaders = {
      'Accept': '*/*',
      'Authorization': localStorage.getItem('logintoken') //头部token
    };
    this.editor.config.menus = [     //菜单配置
      'head',  // 标题
      'bold',  // 粗体
      'fontSize',  // 字号
      'fontName',  // 字体
      'italic',  // 斜体
      'underline',  // 下划线
      'strikeThrough',  // 删除线
      'foreColor',  // 文字颜色
      'backColor',  // 背景颜色
      'link',  // 插入链接
      'list',  // 列表
      'justify',  // 对齐方式
      'quote',  // 引用
      'emoticon',  // 表情
      'image',  // 插入图片
      'table',  // 表格
      'video',  // 插入视频
      'code',  // 插入代码
      'undo',  // 撤销
      'redo'  // 重复
    ];
    //下面是最重要的的方法
    this.editor.config.uploadImgHooks = {
      before: function (xhr, editor, files) {
        // 图片上传之前触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件

        // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
        // return {
        //   prevent: true,
        //   msg: '放弃上传'
        // }
      },
      success: function (xhr, editor, result) {
        // 图片上传并返回结果，图片插入成功之后触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
        this.imgUrl=Object.values(result.data).toString()
      },
      fail: function (xhr, editor, result) {
        // 图片上传并返回结果，但图片插入错误时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
      },
      error: function (xhr, editor) {
        // 图片上传出错时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
      },
      timeout: function (xhr, editor) {
        // 图片上传超时时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
      },

      // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
      // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
      customInsert: function (insertImg, result, editor) {


        //图片批量上传
        if (!Array.isArray(result.data)){
          let url = result.data;   //result.data就是服务器返回的图片名字和链接
          JSON.stringify(url)  //在这里转成JSON格式
          insertImg(url);
        }else{
          for(var j=0;j<result.data.length;j++){
            let url = result.data[j];
            JSON.stringify(url)
            insertImg(url);
          }
        }



      }
    };
    this.editor.create()
  },
  methods: {
    echo(text){

      console.log(text)

      this.editor.txt.html(text);
    }
  }
}
</script>
<style scoped>
.wangeditor >>> .w-e-text-container{
  height: 300px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/wangeditor.vue